// import React, { useEffect, useState } from "react";
// import "./RDDDPreClosure.css";
// import Select from "react-select";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
// import { useNavigate } from "react-router-dom"; // Added for navigation
// import axios from "axios";
// import { toast } from "react-toastify";

// const API_URL = "https://payyug.in/api";

// const RDDDEmiPay = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate(); // Initialize navigate
//   const { profile } = useSelector((state) => state.userProfile);

//   const [accounts, setAccounts] = useState([]);
//   const [selectedAccount, setSelectedAccount] = useState(null);
//   const [lastPaidEmi, setLastPaidEmi] = useState(null);
//   const [currentPendingEmi, setCurrentPendingEmi] = useState(null);
//   const [fullAccountData, setFullAccountData] = useState(null); // Store full response for receipt
//   const [uploadedKyc, setUploadedKyc] = useState([]);
//   const [showPreview, setShowPreview] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [payLoading, setPayLoading] = useState(false);

//   const [formData, setFormData] = useState({
//     amount: "",
//     paymentMode: "CASH",
//     transactionDate: new Date().toISOString().split("T")[0],
//     narration: "",
//   });

//   useEffect(() => {
//     dispatch(fetchUserProfile());
//   }, [dispatch]);

//   const fetchAccountsList = async () => {
//     try {
//       const superAdminId = profile.superAdminId || 14;
//       const branchId = localStorage.getItem("userId") || 56;
//       const res = await axios.get(`${API_URL}/deposit/list`, {
//         params: { superAdminId, branchId },
//       });
//       if (res.data.success) setAccounts(res.data.data || []);
//     } catch (err) {
//       console.error("Error fetching accounts:", err);
//     }
//   };

//   const fetchEmiDetails = async (accountId) => {
//     try {
//       setLoading(true);
//       const res = await axios.get(`${API_URL}/deposit/${accountId}`);
      
//       if (res.data?.success) {
//         const accountData = res.data.data;
//         setFullAccountData(accountData);
//         const schedule = accountData.installments || [];

//         const paid = [...schedule]
//           .sort((a, b) => b.installmentNo - a.installmentNo)
//           .find(item => item.status === "Paid");
//         setLastPaidEmi(paid);

//         const pending = [...schedule]
//           .sort((a, b) => a.installmentNo - b.installmentNo)
//           .find(item => item.status === "Pending");
        
//         setCurrentPendingEmi(pending);

//         if (pending) {
//           setFormData(prev => ({ ...prev, amount: pending.amount }));
//         }
//       }
//     } catch (err) {
//       toast.error("Failed to load EMI schedule");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (profile) fetchAccountsList();
//   }, [profile]);

//   useEffect(() => {
//     if (selectedAccount?.id) {
//       fetchEmiDetails(selectedAccount.id);
//     }
//   }, [selectedAccount]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handlePreview = (e) => {
//     e.preventDefault();
//     if (!selectedAccount) return toast.warn("Please select an account");
//     if (!currentPendingEmi) return toast.error("No pending installments found");
//     setShowPreview(true);
//   };

//   /* ================= FINAL SUBMIT & REDIRECT ================= */
//   const handleSubmit = async () => {
//     try {
//       setPayLoading(true);

//       const payload = {
//         accountId: selectedAccount.id,
//         installmentNo: currentPendingEmi.installmentNo,
//         // Custom logic for DD if needed
//         ...(selectedAccount.accountType === "DD" && {
//           userAmount: Number(formData.amount),
//         }),
//         collectionDate: formData.transactionDate,
//         collectionMode: formData.paymentMode,
//         collectedBy: localStorage.getItem("userId") || 1,
//         remarks: formData.narration || `EMI ${currentPendingEmi.installmentNo} Payment`,
//       };

//       const url = `${API_URL}/deposit/pay-installment`;
//       const res = await axios.post(url, payload);

//       if (res.data.success) {
//         toast.success("Installment Paid Successfully!");
//         setShowPreview(false);
        
//         // Navigate to Receipt Page with state
//         navigate("/Banking/DepositAccount/Depositemireciept", {
//           state: { 
//             account: fullAccountData, 
//             emi: currentPendingEmi,
//             nextemi: null // You can calculate this from schedule if needed
//           },
//         });
//       } else {
//         toast.error(res.data.message || "Payment failed");
//       }
//     } catch (err) {
//       toast.error("An error occurred during payment");
//     } finally {
//       setPayLoading(false);
//     }
//   };

//   useEffect(() => {
//     const fetchKyc = async () => {
//       if (selectedAccount?.customerId) {
//         try {
//           const res = await axios.get(`${API_URL}/list-kyc`, {
//             params: { userId: selectedAccount.customerId, createdId: profile.id }
//           });
//           setUploadedKyc(res.data.documents || []);
//         } catch { setUploadedKyc([]); }
//       }
//     };
//     fetchKyc();
//   }, [selectedAccount, profile?.id]);

//   return (
//     <div className="saving-account-transaction-container">
//       <h2>RD DD EMI Payment Portal</h2>

//       <form className="saving-account-transaction-payment-details" onSubmit={handlePreview}>
//         <h4><i className="fa-solid fa-calendar-check"></i> EMI Schedule Summary</h4>
        
//         <div className="payment-details-container">
//           <div className="payment-details-input-groups">
//             <div className="payment-details-inputs">
//               <label>Select Account</label>
//               <Select
//                 placeholder="Search Account..."
//                 options={accounts.map((acc) => ({
//                   value: acc.id,
//                   label: `${acc.customerName} | ${acc.accountNo}`,
//                   account: acc
//                 }))}
//                 onChange={(selected) => setSelectedAccount(selected?.account)}
//                 isSearchable
//               />
//             </div>
//             <div className="payment-details-inputs">
//               <label>Last Paid EMI (No.)</label>
//               <input 
//                 type="text" 
//                 value={lastPaidEmi ? `EMI #${lastPaidEmi.installmentNo}` : "None"} 
//                 readOnly 
//               />
//             </div>
//           </div>

//           <div className="payment-details-input-groups">
//             <div className="payment-details-inputs">
//               <label>Next Due EMI Date</label>
//               <input 
//                 type="text" 
//                 value={currentPendingEmi ? new Date(currentPendingEmi.dueDate).toLocaleDateString() : "All Paid"} 
//                 readOnly 
//                 style={{ color: '#d9534f', fontWeight: 'bold' }}
//               />
//             </div>
//             <div className="payment-details-inputs">
//               <label>Installment Amount</label>
//               <input 
//                 type="text" 
//                 value={currentPendingEmi ? `₹ ${currentPendingEmi.amount}` : "₹ 0.00"} 
//                 readOnly 
//               />
//             </div>
//           </div>

//           <hr />

//           <div className="payment-details-input-groups">
//             <div className="payment-details-inputs">
//               <label>Collection Amount (INR)</label>
//               <input type="number" name="amount" value={formData.amount} onChange={handleChange} />
//             </div>
//             <div className="payment-details-inputs">
//               <label>Collection Date</label>
//               <input type="date" name="transactionDate" value={formData.transactionDate} onChange={handleChange} />
//             </div>
//           </div>

//           <div className="payment-details-input-groups">
//             <div className="payment-details-inputs">
//               <label>Payment Mode</label>
//               <select name="paymentMode" value={formData.paymentMode} onChange={handleChange}>
//                 <option value="CASH">CASH</option>
//                 <option value="UPI">UPI</option>
//                 <option value="RTGS">NEFT/RTGS</option>
//               </select>
//             </div>
//             <div className="payment-details-inputs">
//               <label>Remarks</label>
//               <input type="text" name="narration" value={formData.narration} onChange={handleChange} placeholder="Optional narration" />
//             </div>
//           </div>
//         </div>

//         <div className="kyc-section-title">Customer KYC Documents</div>
//         <div className="kyc-cards-container">
//           {uploadedKyc.length === 0 ? <p className="no-kyc">No KYC documents found</p> : 
//             uploadedKyc.map((doc, index) => (
//               <div className="kyc-card" key={index}>
//                 <img src={`https://payyug.in/uploads/${doc.docImage}`} alt="KYC" className="kyc-image" />
//                 <p className="doctitle">{doc.docName || "Document"}</p>
//               </div>
//             ))
//           }
//         </div>

//         <div className="pay-btn">
//           <button type="submit" disabled={!currentPendingEmi || loading}>
//             {loading ? "Loading..." : "Verify & Pay EMI"}
//           </button>
//         </div>
//       </form>

//       {showPreview && (
//         <div className="modal-overlay">
//           <div className="transaction-modal">
//             <h3>Confirm EMI Collection</h3>
//             <div className="modal-content">
//               <div className="modal-row"><span>Customer:</span> <strong>{selectedAccount?.customerName}</strong></div>
//               <div className="modal-row"><span>Installment:</span> <strong>No. {currentPendingEmi?.installmentNo}</strong></div>
//               <div className="modal-row"><span>Mode:</span> <strong>{formData.paymentMode}</strong></div>
//               <div className="modal-row amount-row"><span>Payable:</span> <strong>₹ {formData.amount}</strong></div>
//             </div>
//             <div className="modal-actions">
//               <button className="cancel-btn" onClick={() => setShowPreview(false)} disabled={payLoading}>Edit</button>
//               <button className="confirm-btn" onClick={handleSubmit} disabled={payLoading}>
//                 {payLoading ? "Processing..." : "Pay Now"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default RDDDEmiPay;
import React, { useEffect, useState } from "react";
import "./RDDDPreClosure.css";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

const API_URL = "https://payyug.in/api";

const RDDDEmiPay = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { profile } = useSelector((state) => state.userProfile);

  const [accounts, setAccounts] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [lastPaidEmi, setLastPaidEmi] = useState(null);
  const [currentPendingEmi, setCurrentPendingEmi] = useState(null);
  const [fullAccountData, setFullAccountData] = useState(null);
  const [uploadedKyc, setUploadedKyc] = useState([]);
  const [showPreview, setShowPreview] = useState(false);
  const [loading, setLoading] = useState(false);
  const [payLoading, setPayLoading] = useState(false);

  const [formData, setFormData] = useState({
    amount: "",
    paymentMode: "CASH",
    transactionDate: new Date().toISOString().split("T")[0],
    narration: "",
  });

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  const fetchAccountsList = async () => {
    try {
      const superAdminId = profile.superAdminId || 14;
      const branchId = localStorage.getItem("userId") || 56;
      const res = await axios.get(`${API_URL}/deposit/list`, {
        params: { superAdminId, branchId },
      });
      if (res.data.success) setAccounts(res.data.data || []);
    } catch (err) {
      console.error("Error fetching accounts:", err);
    }
  };

  const fetchEmiDetails = async (accountId) => {
    try {
      setLoading(true);
      const res = await axios.get(`${API_URL}/deposit/${accountId}`);
      
      if (res.data?.success) {
        const accountData = res.data.data;
        setFullAccountData(accountData);
        const schedule = accountData.installments || [];

        // Find Last Paid
        const paid = [...schedule]
          .sort((a, b) => b.installmentNo - a.installmentNo)
          .find(item => item.status === "Paid");
        setLastPaidEmi(paid);

        // Find Next Pending
        const pending = [...schedule]
          .sort((a, b) => a.installmentNo - b.installmentNo)
          .find(item => item.status === "Pending");
        
        setCurrentPendingEmi(pending);

        if (pending) {
          setFormData(prev => ({ ...prev, amount: pending.amount }));
        }
      }
    } catch (err) {
      toast.error("Failed to load EMI schedule");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (profile) fetchAccountsList();
  }, [profile]);

  useEffect(() => {
    if (selectedAccount?.id) {
      fetchEmiDetails(selectedAccount.id);
    }
  }, [selectedAccount]);

  /* ================= RECEIPT NAVIGATION LOGIC ================= */
  const navigateToReceipt = (emiObj) => {
    if (!emiObj || !fullAccountData) return;

    // Logic to find the installment immediately following the one being printed
    const schedule = fullAccountData.installments || [];
    const nextEmi = schedule.find(item => item.installmentNo === emiObj.installmentNo + 1);

    navigate("/Banking/DepositAccount/Depositemireciept", {
      state: { 
        account: fullAccountData, 
        emi: emiObj,
        nextemi: nextEmi || null // Used by receipt to show "Next Due Date"
      },
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePreview = (e) => {
    e.preventDefault();
    if (!selectedAccount) return toast.warn("Please select an account");
    if (!currentPendingEmi) return toast.error("No pending installments found");
    setShowPreview(true);
  };

  const handleSubmit = async () => {
    try {
      setPayLoading(true);
      const payload = {
        accountId: selectedAccount.id,
        installmentNo: currentPendingEmi.installmentNo,
        ...(selectedAccount.accountType === "DD" && {
          userAmount: Number(formData.amount),
        }),
        collectionDate: formData.transactionDate,
        collectionMode: formData.paymentMode,
        collectedBy: localStorage.getItem("userId") || 1,
        remarks: formData.narration || `EMI ${currentPendingEmi.installmentNo} Payment`,
      };

      const res = await axios.post(`${API_URL}/deposit/pay-installment`, payload);

      if (res.data.success) {
        toast.success("Installment Paid Successfully!");
        setShowPreview(false);
        
        // After payment, navigate to receipt for the installment just paid
        navigateToReceipt(currentPendingEmi);
      } else {
        toast.error(res.data.message || "Payment failed");
      }
    } catch (err) {
      toast.error("An error occurred during payment");
    } finally {
      setPayLoading(false);
    }
  };

  return (
    <div className="saving-account-transaction-container">
      <h2>RD DD EMI Payment Portal</h2>

      <form className="saving-account-transaction-payment-details" onSubmit={handlePreview}>
        <h4><i className="fa-solid fa-calendar-check"></i> EMI Schedule Summary</h4>
        
        {selectedAccount && (
          <div className="scheme-details-banner">
            <h4><i className="fa-solid fa-circle-info"></i> Scheme Info: {selectedAccount.schemeName}</h4>
            <div className="scheme-info-grid">
              <div className="info-item">
                <span>ROI:</span>
                <strong>{selectedAccount.roi}%</strong>
              </div>
              <div className="info-item">
                <span>Freq:</span>
                <strong>{selectedAccount.installmentFrequency}</strong>
              </div>
              <div className="info-item">
                <span>Lock-in:</span>
                <strong>{selectedAccount.scheme?.depositLockinPeriod} Months</strong>
              </div>
              <div className="info-item">
                <span>Pre-Close ROI:</span>
                <strong>{selectedAccount.scheme?.preClosureRoi}%</strong>
              </div>
              <div className="info-item">
                <span>Late Fine:</span>
                <strong>₹ {selectedAccount.scheme?.installmentPenaltyValue}</strong>
              </div>
              <div className="info-item">
                <span>Status:</span>
                <strong className={`status-${selectedAccount.status.toLowerCase()}`}>
                  {selectedAccount.status}
                </strong>
              </div>
            </div>
          </div>
        )}

        <div className="payment-details-inputs">
          <label>Installment Progress</label>
          <div className="progress-bar-container">
            <div 
              className="progress-fill" 
              style={{ width: `${(selectedAccount?.paidInstallments / selectedAccount?.totalInstallments) * 100}%` }}
            ></div>
            <span className="progress-text">
              {selectedAccount?.paidInstallments || 0} / {selectedAccount?.totalInstallments || 0} Paid
            </span>
          </div>
        </div>
        

        <div className="payment-details-container">
          <div className="payment-details-input-groups">
            <div className="payment-details-inputs">
              <label>Select Account</label>
              <Select
                placeholder="Search Account..."
                options={accounts.map((acc) => ({
                  value: acc.id,
                  label: `${acc.customerName} | ${acc.accountNo}`,
                  account: acc
                }))}
                onChange={(selected) => setSelectedAccount(selected?.account)}
                isSearchable
              />
            </div>
            
            <div className="payment-details-inputs">
              <label>Last Paid EMI (No.)</label>
              <div style={{ display: 'flex', gap: '8px' }}>
                <input 
                  type="text" 
                  value={lastPaidEmi ? `EMI #${lastPaidEmi.installmentNo}` : "None"} 
                  readOnly 
                  style={{ flex: 1 }}
                />
                {lastPaidEmi && (
                  <button 
                    type="button"
                    title="Print Last Receipt"
                    className="last-receipt-btn"
                    onClick={() => navigateToReceipt(lastPaidEmi)}
                    style={{
                      padding: "0 12px",
                      background: "#28a745",
                      color: "white",
                      border: "none",
                      borderRadius: "4px",
                      cursor: "pointer"
                    }}
                  >
                    <i className="fa-solid fa-print"></i>
                  </button>
                )}
              </div>
            </div>
          </div>
          
          
          <div className="payment-details-input-groups">
            <div className="payment-details-inputs">
              <label>Next Due Date</label>
              <input 
                type="text" 
                value={currentPendingEmi ? new Date(currentPendingEmi.dueDate).toLocaleDateString('en-IN', { day: '2-digit', month: 'long', year: 'numeric' }) : "No Pending"} 
                readOnly 
                className="due-date-input-highlight"
              />
            </div>
            <div className="payment-details-inputs">
              <label>Installment Amount</label>
              <input 
                type="text" 
                value={currentPendingEmi ? `₹ ${currentPendingEmi.amount}` : "₹ 0.00"} 
                readOnly 
              />
            </div>
          </div>

          <hr />

          <div className="payment-details-input-groups">
            <div className="payment-details-inputs">
              <label>Collection Amount (INR)</label>
              <input type="number" name="amount" value={formData.amount} onChange={handleChange} readOnly/>
            </div>
            <div className="payment-details-inputs">
              <label>Collection Date</label>
              <input type="date" name="transactionDate" value={formData.transactionDate} onChange={handleChange} />
            </div>
          </div>

          <div className="payment-details-input-groups">
            <div className="payment-details-inputs">
              <label>Payment Mode</label>
              <select name="paymentMode" value={formData.paymentMode} onChange={handleChange}>
                <option value="CASH">CASH</option>
                <option value="UPI">UPI</option>
                <option value="RTGS">NEFT/RTGS</option>
              </select>
            </div>
            <div className="payment-details-inputs">
              <label>Remarks</label>
              <input type="text" name="narration" value={formData.narration} onChange={handleChange} placeholder="Optional narration" />
            </div>
          </div>
        </div>


        <div className="kyc-section-title">Customer KYC Documents</div>
        <div className="kyc-cards-container">
          {uploadedKyc.length === 0 ? <p className="no-kyc">No KYC documents found</p> : 
            uploadedKyc.map((doc, index) => (
              <div className="kyc-card" key={index}>
                <img src={`https://payyug.in/uploads/${doc.docImage}`} alt="KYC" className="kyc-image" />
                <p className="doctitle">{doc.docName || "Document"}</p>
              </div>
            ))
          }
        </div>

        <div className="pay-btn">
          <button type="submit" disabled={!currentPendingEmi || loading}>
            {loading ? "Loading..." : "Verify & Pay EMI"}
          </button>
        </div>
      </form>

        {showPreview && (
          <div className="modal-overlay">
            <div className="transaction-modal">
              <h3>Confirm EMI Collection</h3>
              <div className="modal-content">
                <div className="modal-row"><span>Customer:</span> <strong>{selectedAccount?.customerName}</strong></div>
                <div className="modal-row"><span>Installment:</span> <strong>No. {currentPendingEmi?.installmentNo}</strong></div>
                <div className="modal-row"><span>Mode:</span> <strong>{formData.paymentMode}</strong></div>
                <div className="modal-row amount-row"><span>Payable:</span> <strong>₹ {formData.amount}</strong></div>
              </div>
              <div className="modal-actions">
                <button className="cancel-btn" onClick={() => setShowPreview(false)} disabled={payLoading}>Edit</button>
                <button className="confirm-btn" onClick={handleSubmit} disabled={payLoading}>
                  {payLoading ? "Processing..." : "Pay Now"}
                </button>
              </div>
            </div>
          </div>
        )}
    </div>
  );
};

export default RDDDEmiPay;